import { Box } from "@mui/material";
import React from "react";

const Concentration = ({ percentage, image, shortDescription }) => {
  return (
    <div className="concentration">
      <div className="with-percentage">
        <div className="with">With</div>
        <div className="percentage">
          {percentage} <span>%</span>
        </div>
      </div>
      <div className="image-container">
        <Box
          component="img"
          sx={{
            objectFit: "contain",
            width: "100%",
            height: "100%",
          }}
          src={image}
        />
      </div>
      <div className="concentration-text">
        <div className="title">CONCENTRATION</div>
        <div className="desc">{shortDescription}</div>
      </div>
    </div>
  );
};

export default Concentration;
